export const Role = {
  Admin: 'ADMIN',
  Director: 'DIRECTOR',
  ManageSchedule: 'MANAGESCHEDULE',
  Floater: 'FLOATER',
  CloseAccount: 'REPORTCLOSING',
  ViewFinance: 'REPORTFINANCE',
  ViewAcademic: 'REPORTACADEMIC',
  ViewCustomer: 'REPORTCUSTOMER',
  ViewStaff: 'REPORTSTAFF',
  Super: 'SUPER',
};
